var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5940_132987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6812 15.4439L12.0367 2.2032C11.6116 1.46695 10.8502 1.02734 9.99999 1.02734C9.14979 1.02734 8.38839 1.46695 7.96331 2.2032L0.318837 15.4438C-0.106279 16.1802 -0.106279 17.0593 0.318837 17.7956C0.743954 18.5319 1.50528 18.9714 2.35551 18.9714H17.6445C18.4947 18.9714 19.256 18.5318 19.6812 17.7956C20.1063 17.0593 20.1063 16.1802 19.6812 15.4439ZM18.6664 17.2098C18.4531 17.5792 18.0711 17.7998 17.6445 17.7998H2.35551C1.92887 17.7998 1.54684 17.5792 1.33356 17.2098C1.12028 16.8403 1.12028 16.3992 1.33356 16.0298L8.97812 2.7891C9.1914 2.41965 9.57343 2.1991 10 2.1991C10.4266 2.1991 10.8087 2.41965 11.0219 2.7891L18.6665 16.0298C18.8797 16.3992 18.8797 16.8403 18.6664 17.2098Z",
    fill: "#0077B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41402 6.875H10.5857V12.7337H9.41402V6.875ZM9.99992 13.9055C9.56918 13.9055 9.21875 14.2559 9.21875 14.6866C9.21875 15.1174 9.56918 15.4678 9.99992 15.4678C10.4306 15.4678 10.7811 15.1174 10.7811 14.6866C10.7811 14.2559 10.4307 13.9055 9.99992 13.9055Z",
    fill: "#0077B5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5940_132987"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.5bf4ebea4d7f9b833ec06fc63220a40a.svg";
export { ForwardRef as ReactComponent };